<template>
  <div>
    <v-navigation-drawer
      app
      :mini-variant="mini"
      clipped
      dark
      v-model="drawer"
      color="rgb(48, 97, 138)"
    >
      <v-divider></v-divider>
      <div class="mt-4 mb-4">
        <v-flex class="center">
          <v-avatar
            :color="`grey lighten-2`"
            elevation="3"
            :size="mini ? 40 : 120"
            align="center"
            justify="center"
          >
            <v-img
              contain
              :src="$store.state.image == null ? logoReady : $store.state.image"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-icon v-if="logoReady" class="mx-auto" :size="mini ? 40 : 120"
                    >mdi-home-city</v-icon
                  >
                </v-row>
              </template>
            </v-img>
          </v-avatar>
        </v-flex>
        <v-list-item color="rgba(0, 0, 0, .4)" v-if="!mini" class="center" dark>
          <v-list-item-content>
            <v-list-item-title class="mt-2 subtitle-1"
              >{{ $store.state.firstName }} {{ $store.state.lastName }}</v-list-item-title
            >
            <v-list-item-title class="subtitle-2 font-weight-light">{{
              $store.state.email
            }}</v-list-item-title>
            <!-- <v-list-item-title class="mt-2">{{companyEmailContact}}</v-list-item-title> -->
          </v-list-item-content>
        </v-list-item>
      </div>

      <v-divider></v-divider>
      <v-list>
        <v-list-item link :to="{ path: '/company' }">
          <v-list-item-icon>
            <v-icon>mdi-home-city</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">
              {{ $vuetify.lang.t("$vuetify.defaultLayout.sidebar.companyManagement") }}
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      
      <v-list>
        <v-list-item link :to="{ path: '/withdraw' }">
          <v-list-item-icon>
            <v-icon>monetization_on</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">{{
              $vuetify.lang.t("$vuetify.defaultLayout.sidebar.withdraw")
            }}</span>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list>
        <v-list-item link :to="{ path: '/specialevent' }">
          <v-list-item-icon>
            <v-icon>event_note</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">
              {{ $vuetify.lang.t("$vuetify.defaultLayout.sidebar.specialEvent") }}
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-list>
        <v-list-item link :to="{ path: '/category' }">
          <v-list-item-icon>
            <v-icon>category</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <span class="subtitle-1 font-weight-light">
              {{ $vuetify.lang.t("$vuetify.defaultLayout.sidebar.category") }}
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar dense app clipped-left flat color="white" elevation="2">
      <v-app-bar-nav-icon
        v-if="!isResponsive"
        @click="appBarIconMiniOnClick"
      ></v-app-bar-nav-icon>
      <v-app-bar-nav-icon
        v-if="isResponsive"
        @click="appBarIconDrawerOnClick"
      ></v-app-bar-nav-icon>

      <v-toolbar-title class="text-uppercase">
        <span>{{ $store.state.title }}</span>
      </v-toolbar-title>

      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn class="d-flex align-center black--text" outlined dark text v-on="on">
            <!-- <v-icon color="black">account_circle</v-icon> -->
            <v-list-item-avatar size="20">
              <img :src="$store.state.image" />
            </v-list-item-avatar>
            <div>{{ $store.state.displayName }}</div>
          </v-btn>
          <div class="text-center language">
            <v-menu open-on-hover offset-y>
              <template v-slot:activator="{ on }">
                <v-btn class="d-flex align-center mr-3" outlined dark text v-on="on">
                  <v-img
                    class="shrink mr-1"
                    contain
                    :src="src"
                    transition="scale-transition"
                    width="20"
                  />

                  <span class="font-italic black--text font-weight-thin">{{
                    currentlanguage
                  }}</span>
                  <!-- <span class="hidden sm:block ml-2">{{ getCurrentLocaleData.lang }}</span> -->
                </v-btn>
              </template>
              <v-list v-model="currentLocale">
                <v-list-item @click="changeLocale('en')">
                  <v-img
                    class="shrink mr-1"
                    width="20"
                    src="@/assets/layout/en.png"
                    alt="en"
                  />
                  <span :style="{ color: $store.state.themeColor }">&nbsp;English</span>
                </v-list-item>
                <v-list-item @click="changeLocale('th')">
                  <v-img
                    class="shrink mr-1"
                    width="20"
                    src="@/assets/layout/th.png"
                    alt="th"
                  />
                  <span :style="{ color: $store.state.themeColor }">&nbsp;Thailand</span>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </template>
        <v-list max-width="300" dark>
          <div>
            <v-list-item color="rgba(0, 0, 0, .4)" class="center" dark>
              <v-list-item-content>
                <div class="center">
                  <v-avatar :size="60" align="center" justify="center">
                    <img :src="$store.state.image" />
                  </v-avatar>
                </div>

                <v-list-item-title class="mt-2 mb-2">{{
                  $store.state.firstName + " " + $store.state.lastName
                }}</v-list-item-title>
                <v-list-item-subtitle>{{ $store.state.email }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </div>
          <v-divider></v-divider>

          <v-list>
            <v-list-item link @click="onClickProfile">
              <v-list-item-icon>
                <v-icon>mdi-account-edit-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{
                  $vuetify.lang.t("$vuetify.defaultLayout.profile")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item v-model="currentLocale" @click="onLogout">
              <v-list-item-icon>
                <v-icon>mdi-logout-variant</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{
                  $vuetify.lang.t("$vuetify.defaultLayout.logout")
                }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-list>
      </v-menu>
    </v-app-bar>

    <v-content class="content-container ma-0">
      <transition name="fade">
        <router-view></router-view>
      </transition>
    </v-content>

    <v-dialog v-model="dialogFormUser" scrollable persistent max-width="800px">
      <v-card>
        <v-toolbar flat dark color="rgb(51, 97, 137)">
          <v-toolbar-title>
            <h4 class="font-weight-light ml-3">
              <v-icon left>mdi-account-edit-outline</v-icon>
              {{ $vuetify.lang.t("$vuetify.defaultLayout.editProfile") }}
            </h4>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="onCloseEditProfile">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text class="pr-5 pl-5">
          <v-form ref="form" v-model="valid" v-on:submit.prevent="validate" id="form">
            <v-container>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <p>
                    {{ $vuetify.lang.t("$vuetify.defaultLayout.uploadPhoto") }}
                  </p>
                  <v-file-input
                    v-model="imageFile"
                    @change="preview"
                    class="text-field-border mb-9"
                    solo
                    dense
                    flat
                    show-size
                    accept="image/png, image/jpeg, image/bmp"
                    :label="
                      profile.image
                        ? $vuetify.lang.t('$vuetify.defaultLayout.chooseNewPhoto')
                        : $vuetify.lang.t('$vuetify.defaultLayout.choosePhoto')
                    "
                    prepend-icon="mdi-camera ml-2 mb-1"
                  ></v-file-input>
                  <div class="img-padding">
                    <v-avatar :color="`grey lighten-2`" elevation="3" size="230">
                      <v-img :src="profile.image" aspect-ratio="1">
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <!-- <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular> -->
                            <v-icon
                              v-if="!imageReady"
                              class="mx-auto"
                              width="240px"
                              height="240px"
                              elevation="3"
                              size="200"
                              color="white"
                              >mdi-account-circle</v-icon
                            >
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <p>
                    {{ $vuetify.lang.t("$vuetify.defaultLayout.gender") }}
                    <span class="red--text">*</span>
                  </p>
                  <v-autocomplete
                    v-model="profile.gender"
                    class="text-field-border mb-5"
                    solo
                    dense
                    flat
                    :items="genders"
                    item-text="text"
                    item-value="value"
                    :placeholder="$vuetify.lang.t('$vuetify.defaultLayout.gender')"
                  ></v-autocomplete>
                  <p>
                    {{ $vuetify.lang.t("$vuetify.defaultLayout.firstName") }}
                    <span class="red--text">*</span>
                  </p>
                  <v-text-field
                    class="text-field-border mb-5"
                    solo
                    dense
                    flat
                    clear-icon="mdi-close mb-2"
                    :rules="firstNameRules"
                    clearable
                    :placeholder="$vuetify.lang.t('$vuetify.defaultLayout.firstName')"
                    v-model="profile.firstName"
                  ></v-text-field>
                  <p>
                    {{ $vuetify.lang.t("$vuetify.defaultLayout.lastName") }}
                    <span class="red--text">*</span>
                  </p>
                  <v-text-field
                    class="text-field-border mb-5"
                    solo
                    dense
                    flat
                    clear-icon="mdi-close mb-2"
                    :rules="lastNameRules"
                    clearable
                    :placeholder="$vuetify.lang.t('$vuetify.defaultLayout.lastName')"
                    v-model="profile.lastName"
                  ></v-text-field>
                  <p>
                    {{ $vuetify.lang.t("$vuetify.defaultLayout.note") }}
                  </p>
                  <v-text-field
                    class="text-field-border mb-5"
                    solo
                    dense
                    flat
                    clear-icon="mdi-close mb-2"
                    clearable
                    :placeholder="$vuetify.lang.t('$vuetify.defaultLayout.note')"
                    v-model="profile.school"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <p>
                    {{ $vuetify.lang.t("$vuetify.defaultLayout.email") }}
                    <span class="red--text">*</span>
                  </p>
                  <v-text-field
                    class="text-field-border mb-5"
                    solo
                    dense
                    flat
                    clear-icon="mdi-close mb-2"
                    :rules="emailRules"
                    clearable
                    :placeholder="$vuetify.lang.t('$vuetify.defaultLayout.email')"
                    v-model="profile.email"
                  ></v-text-field>
                </v-col>

                <v-col cols="6">
                  <p>
                    {{ $vuetify.lang.t("$vuetify.defaultLayout.username") }}
                  </p>
                  <v-text-field
                    class="text-field-border mb-5"
                    solo
                    dense
                    flat
                    clear-icon="mdi-close mb-2"
                    clearable
                    :placeholder="$vuetify.lang.t('$vuetify.defaultLayout.username')"
                    disabled
                    v-model="profile.username"
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-checkbox
                    v-model="checkboxPassword"
                    @change="onCheckPassword"
                    :label="$vuetify.lang.t('$vuetify.defaultLayout.updatePass')"
                  ></v-checkbox>
                </v-col>

                <v-col cols="12" v-if="checkboxPassword">
                  <p>
                    {{ $vuetify.lang.t("$vuetify.defaultLayout.oldPass") }}
                    <span v-if="checkboxPassword" class="red--text">*</span>
                  </p>
                  <v-text-field
                    :type="showOldPassword ? 'text' : 'password'"
                    class="text-field-border mb-5"
                    solo
                    dense
                    flat
                    clear-icon="mdi-close mb-2"
                    clearable
                    :placeholder="$vuetify.lang.t('$vuetify.defaultLayout.oldPass')"
                    :disabled="!checkboxPassword"
                    :rules="passwordRules"
                    v-model="oldPassword"
                    :append-icon="!showOldPassword ? 'mdi-eye mb-2' : 'mdi-eye-off mb-2'"
                    @click:append="showOldPassword = !showOldPassword"
                  ></v-text-field>

                  <p>
                    {{ $vuetify.lang.t("$vuetify.defaultLayout.newPass") }}
                    <span v-if="checkboxPassword" class="red--text">*</span>
                  </p>
                  <v-text-field
                    :type="showNewPassword ? 'text' : 'password'"
                    class="text-field-border mb-5"
                    solo
                    dense
                    flat
                    clearable
                    :rules="passwordRules"
                    :placeholder="$vuetify.lang.t('$vuetify.defaultLayout.newPass')"
                    :disabled="!checkboxPassword"
                    v-model="newPassword"
                    :append-icon="!showNewPassword ? 'mdi-eye mb-2' : 'mdi-eye-off mb-2'"
                    @click:append="showNewPassword = !showNewPassword"
                  ></v-text-field>

                  <p>
                    {{ $vuetify.lang.t("$vuetify.defaultLayout.confirmPass") }}
                    <span v-if="checkboxPassword" class="red--text">*</span>
                  </p>
                  <v-text-field
                    :type="showConfirmPassword ? 'text' : 'password'"
                    class="text-field-border mb-5"
                    solo
                    dense
                    flat
                    id="confirm-password"
                    clearable
                    :rules="conFirmPasswordRules"
                    :disabled="!checkboxPassword"
                    :placeholder="$vuetify.lang.t('$vuetify.defaultLayout.confirmPass')"
                    v-model="confirmPassword"
                    :append-icon="
                      !showConfirmPassword ? 'mdi-eye mb-2' : 'mdi-eye-off mb-2'
                    "
                    @click:append="showConfirmPassword = !showConfirmPassword"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <!-- <v-divider></v-divider> -->
        <v-card-actions class="pb-6 pr-8">
          <v-spacer></v-spacer>
          <v-btn
            color="grey"
            width="100"
            class="text-capitalize"
            outlined
            @click="onCloseEditProfile"
            >{{ $vuetify.lang.t("$vuetify.defaultLayout.cancel") }}</v-btn
          >
          <v-btn
            class="text-capitalize"
            color="rgb(66, 154, 216)"
            outlined
            width="100"
            :disabled="!valid"
            @click="validate"
            >{{ $vuetify.lang.t("$vuetify.defaultLayout.save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- edit dialog success / fail / dupplicate -->
    <completeDialog
      v-bind:cm_dialog.sync="editDialog.isShow"
      v-bind:cm_title.sync="editDialog.title"
      v-bind:cm_color.sync="editDialog.colorBtn"
      v-bind:cm_text="editDialog.text"
      @done="onCloseEditProfileSuccess"
    ></completeDialog>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import { EventBus } from "@/event-bus";
import { editProfile, updatePassword } from "@/service/account/manageUser";
import { getInfo, logout } from "@/service/account/login";
import { uploadImage } from "@/service/upload/upload";
import completeDialog from "@/components/completeDialog";

export default Vue.extend({
  components: {
    completeDialog,
  },
  data: function () {
    return {
      admins: [
        ["Management", "people_outline"],
        ["Settings", "settings"],
      ],
      src: "",
      logoReady: true,
      userInfo: {},
      companyName: "",
      userName: "",
      picture: "",
      isResponsive: false,
      drawer: false,
      mini: false,
      currentLocale: 0,
      languages: [
        {
          title: "en",
          img: require("../assets/layout/en.png"),
        },
        {
          title: "th",
          img: require("../assets/layout/de.png"),
        },
      ],
      currentlanguage: "en",
      // currentlanguage: "th",

      editDialog: {
        isShow: false,
        title: this.$vuetify.lang.t("$vuetify.defaultLayout.editingUserSucceeded"),
        text: this.$vuetify.lang.t("$vuetify.defaultLayout.userInformationUpdated"),
        colorBtn: "success",
      },
      profile: {
        gender: null,
        username: "",
        firstName: "",
        lastName: "",
        studentCode: "",
        email: "",
        school: "",
        image: "",
        identificationNumber: "",
      },
      // Profile
      valid: true,
      dialogFormUser: false,
      checkboxPassword: false,
      scrollBottom: false,
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false,

      oldPassword: "",
      newPassword: "",
      confirmPassword: "",

      imgURL: "",
      imageFile: null,
      imageReady: false,
      accountManagementActive: false,
      dataManagementActive: false,

      companyEmailContact: "",

      // companyEmailContact: this.$store.state.company.contactEmail,

      genders: [
        {
          text: this.$vuetify.lang.t("$vuetify.defaultLayout.male"),
          // text: "หญิง",
          value: "male",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.defaultLayout.female"),
          // text: "ชาย",
          value: "female",
        },
        {
          text: this.$vuetify.lang.t("$vuetify.defaultLayout.unknown"),
          // text: "ไม่ระบุ",
          value: null,
        },
      ],
      imageRules: [
        // v => !!v || this.$vuetify.lang.t("$vuetify.plsUploadPhoto"),
        (v) => v.size < 20000000 || this.$vuetify.lang.t("$vuetify.plsChooseUnder20MB"),
      ],
      nameRules: [(v) => !!v || this.$vuetify.lang.t("$vuetify.plsEnterAllData")],
      firstNameRules: [
        (v) => !!v || this.$vuetify.lang.t("$vuetify.defaultLayout.enterFirstname"),
      ],
      lastNameRules: [
        (v) => !!v || this.$vuetify.lang.t("$vuetify.defaultLayout.enterLastname"),
      ],
      genderRules: [
        (v) => !!v || this.$vuetify.lang.t("$vuetify.defaultLayout.enterGender"),
      ],
      userNameRules: [
        (v) => !!v || this.$vuetify.lang.t("$vuetify.defaultLayout.enterUsername"),
      ],

      emailRules: [
        (v) => !!v || this.$vuetify.lang.t("$vuetify.defaultLayout.enterEmail"),
        (v) => /.+@.+\..+/.test(v) || "กรุณากรอกให้อยู่ในรูปแบบอีเมล",
      ],
    };
  },
  computed: {
    sidebarMenus() {
      return [
        {
          title: this.$vuetify.lang.t("$vuetify.defaultLayout.sidebar.accountManagement"),
          icon: "mdi-account-group",
          to: {
            path: "/account",
          },

          items: [
            {
              title: this.$vuetify.lang.t("$vuetify.defaultLayout.sidebar.user"),
              icon: "mdi-account-outline",
              to: {
                path: "/users",
              },
            },
            {
              title: this.$vuetify.lang.t("$vuetify.defaultLayout.sidebar.instructor"),
              icon: "mdi-account-tie-outline",
              to: {
                path: "/account",
              },
            },
          ],
        },
      ];
    },

    passwordRules() {
      const rules = [];

      if (this.checkboxPassword == true) {
        rules.push(
          (v) =>
            v.length >= 8 ||
            this.$vuetify.lang.t("$vuetify.defaultLayout.least8characters")
        );
      }

      return rules;
    },
    conFirmPasswordRules() {
      const rules = [];
      if (this.checkboxPassword == true) {
        rules.push(
          (v) =>
            (!!v && v) === this.newPassword ||
            this.$vuetify.lang.t("$vuetify.defaultLayout.matchedPassword")
        );
        rules.push(
          (v) =>
            v.length >= 8 ||
            this.$vuetify.lang.t("$vuetify.defaultLayout.least8characters")
        );
      }
      return rules;
    },
  },
  updated() {
    if (this.$vuetify.lang.current === "en") this.currentLocale = 0;
    else this.currentLocale = 1;

    if (this.$vuetify.breakpoint.lgAndUp) {
      this.drawer = true;
      this.isResponsive = false;
    } else {
      this.isResponsive = true;
    }
  },
  mounted() {
    this.companyEmailContact = this.$store.state.company.contactEmail;
    if (this.$vuetify.breakpoint.lgAndUp) {
      this.drawer = true;
      this.isResponsive = false;
    } else {
      this.isResponsive = true;
    }
    this.currentLocale == 0
      ? (this.src = require("@/assets/layout/en.png"))
      : (this.src = require("@/assets/layout/th.png"));
  },
  methods: {
    onCheckPassword() {
      let firstElement = document.getElementById("form");
      let lastElement = document.getElementById("confirm-password");

      if (this.scrollBottom) {
        firstElement.scrollIntoView({
          behavior: "smooth",
        });
      } else {
        lastElement.scrollIntoView({
          behavior: "smooth",
        });
      }

      this.scrollBottom = !this.scrollBottom;
    },
    onClickProfile() {
      this.dialogFormUser = true;
      this.profile.firstName = this.$store.state.firstName;
      this.profile.lastName = this.$store.state.lastName;
      this.profile.email = this.$store.state.email;
      this.profile.school = this.$store.state.school;
      this.profile.username = this.$store.state.username;
      this.profile.image = this.$store.state.image;
      this.imgURL = this.$store.state.image;
      this.profile.gender = this.genders.filter(
        (gender) => gender.value == this.$store.state.gender
      )[0].value;
    },
    async onLogout() {
      await logout();
      await this.$store.commit("clear");
      await localStorage.clear();
      await this.$router.replace({
        path: "/login",
      });
    },
    async validate() {
      if (this.$refs.form.validate()) {
        if (this.profile.image) {
          this.preview();
        }
        let status = await editProfile(this.profile);
        if (status.message == "username or email duplicade") {
          // this.dialogUsernameDuplicade = true; //กรณีชื่อซ้ำ
          this.alertCompleDialog(
            "บันทึกไม่สำเร็จ",
            "อีเมล หรือชื่อผู้ใช้นี้ได้ถูกใช้ไปแล้ว กรุณาใช้ชื่ออื่น",
            "error"
          );
          return;
        } else if (status.code) {
          //this.dialogEditFail = true; //กรณี error อื่น
          this.alertCompleDialog(
            "แก้ไขผู้ใช้งานไม่สำเร็จ",
            "เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง",
            "error"
          );
          return;
        }

        if (this.checkboxPassword) {
          let updatePasswordResult = await updatePassword({
            passwordold: this.oldPassword,
            passwordnew: this.newPassword,
          });
          updatePasswordResult.code !== 403
            ? localStorage.setItem("x-session-token", updatePasswordResult.token)
            : null;
          if (updatePasswordResult.code == 403) {
            // this.dialogEditFail = true; //กรณี error อื่น
            this.alertCompleDialog(
              "แก้ไขผู้ใช้งานไม่สำเร็จ",
              "เกิดข้อผิดพลาดในการเพิ่มข้อมูล กรุณาลองใหม่อีกครั้ง",
              "error"
            );
            return;
          }
        }
        //this.dialogEditSuccess = true;
        this.alertCompleDialog(
          this.$vuetify.lang.t("$vuetify.defaultLayout.editingUserSucceeded"),
          this.$vuetify.lang.t("$vuetify.defaultLayout.userInformationUpdated")
        );
        let resultInfo = await getInfo();
        await this.$store.commit("setTheme", resultInfo.info);
      } else {
        console.log("not pass");
      }
    },
    async uploadImg(image) {
      let status = await uploadImage("user", image);
      return status;
    },
    async preview() {
      if (this.imageFile != null) {
        this.imgURL = await this.uploadImg(this.imageFile);
        this.profile.image = this.imgURL;
        this.imageReady = true;
      } else {
        this.imageReady = false;
      }
    },
    changeLocale(locale) {
      this.src =
        locale === "en"
          ? require("@/assets/layout/en.png")
          : require("@/assets/layout/th.png");
      this.currentlanguage = locale;
      EventBus.$emit("change-locale", locale);
    },

    onCloseEditProfile() {
      this.dialogFormUser = false;
      this.checkboxPassword = false;
      this.oldPassword = "";
      this.newPassword = "";
      this.confirmPassword = "";
      this.showOldPassword = false;
      this.showNewPassword = false;
      this.showConfirmPassword = false;
    },

    onCloseEditProfileSuccess(value) {
      // this.dialogEditSuccess = false;
      this.editDialog.isShow = value;
      this.onCloseEditProfile();
    },

    alertCompleDialog(title, text, color = "success") {
      this.editDialog.isShow = true;
      this.editDialog.title = title;
      this.editDialog.text = text;
      this.editDialog.colorBtn = color;
    },

    appBarIconDrawerOnClick() {
      this.drawer = !this.drawer;
      this.accountManagementActive = false;
      this.dataManagementActive = false;
    },
    appBarIconMiniOnClick() {
      this.mini = !this.mini;
      this.accountManagementActive = false;
      this.dataManagementActive = false;
    },
  },
});
</script>

<style scoped>
.img-circle {
  border-radius: 50px;
}

.img-padding {
  display: flex;
  align-items: center;
  justify-content: center;
}

.sizeImgCompany {
  position: relative;
  width: 60%;
  height: 60%;
}

.text_green {
  color: green;
}

.font-black {
  color: black;
}

/* .v-application--is-ltr .v-toolbar__content > .v-btn.v-btn--icon:last-child,
.v-application--is-ltr .v-toolbar__extension > .v-btn.v-btn--icon:last-child {
  margin-right: unset;
  float: right;
  width: unset;
} */
.v-list-group .v-list-group__header .v-list-item__icon.v-list-group__header__append-icon {
  align-self: center;
  margin: 0;
  min-width: 48px;
  justify-content: flex-end;
  display: none;
}

.v-list-item__icon .v-list-group__header__append-icon {
  visibility: hidden;
}

.v-application .v-list-group--active {
  color: white !important;
  caret-color: white !important;
}

.v-list {
  padding: 0 0;
}

.v-list--dense .v-list-item .v-list-item__title {
  line-height: normal;
}

.language {
  /* margin-right: 30px; */
}

.content-container {
  margin: 10px 10px 10px 10px;
}

.center {
  text-align: center;
}

.text-field-border {
  border: 1px solid;
  border-color: rgba(65, 65, 65, 0.3);
  background-color: white;
  height: 40px;
  color: rgb(77, 77, 77);
}
</style>
